import { Injectable, inject } from "@angular/core";
import { MatomoTracker } from "ngx-matomo-client";

/** Matomo category for push-tilbudsfunnelen. */
export const PUSH_MATOMO_CATEGORY = "Push";

/** Antal dage før soft-reminder / tilbud kan vises igen efter afvisning. */
export const PUSH_OFFER_COOLDOWN_DAYS = 14;

export type PushSkipReason =
    | "not_logged_in"
    | "not_capacitor"
    | "fof_user"
    | "no_installation"
    | "status_error"
    | "already_subscribed"
    | "cooldown"
    | "status_pending"
    | "os_denied";

/**
 * Konsistent Matomo-tracking for push-events (samme mønster som login/app-launch).
 * Site-id sættes allerede pr. værk via initMatomoFromUmbraco.
 */
@Injectable({ providedIn: "root" })
export class PushTelemetryService {
    private readonly matomoTracker = inject(MatomoTracker, { optional: true });

    public track(action: string, name?: string): void {
        try {
            this.matomoTracker?.trackEvent(PUSH_MATOMO_CATEGORY, action, name);
        } catch {
            // Matomo må ikke vælte push-flowet
        }
    }

    public trackSkip(reason: PushSkipReason): void {
        this.track("offer_skipped", reason);
    }
}
